var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column",style:(_vm.cardStyle)},[_c('section',{staticClass:"d-flex align-center flex-grow-1",class:_vm.isFullScreen ? 'px-0' : 'px-2'},[_c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('InscritosTextView',{attrs:{"count":_vm.formattedCount,"posicao-card":_vm.posicaoCard}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }